import React, { FC, ReactElement, memo } from 'react';
import Link from 'next/link';
import classNames from 'classnames/bind';
import { TopArticlesCard } from 'sections/Home/components/TopArticlesCard';
import { TopArticlesCardType } from 'sections/Home/types';
import styles from 'sections/Home/components/SectionTopArticles/SectionTopArticles.module.scss';

const cn = classNames.bind(styles);

interface SectionTopArticlesProps {
  articles: TopArticlesCardType[];
}

const SectionTopArticles: FC<SectionTopArticlesProps> = memo(({ articles: newsData }): ReactElement => {
  const cardElements = newsData?.map((card: TopArticlesCardType, index: number) => {
    return (
      <TopArticlesCard
        key={card.id}
        index={++index}
        title={card.title}
        tag={card.tag}
        date={card.date}
        url={card.url}
      />
    );
  });

  return (
    <section className={cn('top-articles')}>
      <div className={cn('container')}>
        <h2 className={cn('top-articles__title')}>
          <span>Top articles</span>
          <div className={cn('top-articles__buttons')}>
            <Link className={cn('top-articles__button-view')} href="/blog">
              View all articles
              <svg viewBox="0 0 10 10" aria-hidden="true">
                <path d="M1 5h7" />
                <path d="M2 1l4 4-4 4" />
              </svg>
            </Link>
          </div>
        </h2>
        <ul className={cn('top-articles__cards-list')}>{cardElements}</ul>
      </div>
    </section>
  );
});

export default SectionTopArticles;
